import { M1ApiError, type M1AppApi } from "../../modules/m1-app/data/M1AppApi";

/** Load a complete application catalogue, never silently accept a partial page
 * set. App mutations invalidate the shared m1-apps query namespace. */
export async function loadApplicationOptions(api: Pick<M1AppApi, "listApps">) {
  const filters = { keyword: "", status: "all" as const, pageSize: 100 };
  const first = await api.listApps({ ...filters, page: 1 });
  const items = [...first.items];
  const ids = new Set(items.map(item => item.id));
  const incomplete = () => new M1ApiError("APPLICATION_OPTIONS_INCOMPLETE", "应用列表发生变化或加载不完整，请刷新后重试");
  if (ids.size !== items.length || items.length > first.total || (!items.length && first.total > 0)) throw incomplete();
  for (let page = 2; items.length < first.total; page++) {
    const next = await api.listApps({ ...filters, page });
    if (next.total !== first.total || !next.items.length || items.length + next.items.length > first.total) throw incomplete();
    for (const item of next.items) {
      if (ids.has(item.id)) throw incomplete();
      ids.add(item.id);
      items.push(item);
    }
  }
  return items;
}
